<template>
  <div class="cs-twofa">
    <div class="cs-twofa__hide-result">
      {{ code }}
    </div>
    <input
      class="cs-twofa__input"
      v-model="input0"
      ref="input0"
      @focus="handleFocus(0)"
      @keydown.delete="handleDelete(0, $event)"
      @input="handleInput(0)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 1"
    >
    <input
      class="cs-twofa__input"
      v-model="input1"
      ref="input1"
      @focus="handleFocus(1)"
      @keydown.delete="handleDelete(1, $event)"
      @input="handleInput(1)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 2"
    >
    <input
      class="cs-twofa__input"
      v-model="input2"
      ref="input2"
      @focus="handleFocus(2)"
      @keydown.delete="handleDelete(2, $event)"
      @input="handleInput(2)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 3"
    >
    <input
      class="cs-twofa__input"
      v-model="input3"
      ref="input3"
      @focus="handleFocus(3)"
      @keydown.delete="handleDelete(3, $event)"
      @input="handleInput(3)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 4"
    >
    <input
      class="cs-twofa__input"
      v-model="input4"
      ref="input4"
      @focus="handleFocus(4)"
      @keydown.delete="handleDelete(4, $event)"
      @input="handleInput(4)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 5"
    >
    <input
      class="cs-twofa__input"
      v-model="input5"
      ref="input5"
      @focus="handleFocus(5)"
      @keydown.delete="handleDelete(5, $event)"
      @input="handleInput(5)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 6"
    >
    <input
      class="cs-twofa__input"
      v-model="input6"
      ref="input6"
      @focus="handleFocus(6)"
      @keydown.delete="handleDelete(6, $event)"
      @input="handleInput(6)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 7"
    >
    <input
      class="cs-twofa__input"
      v-model="input7"
      ref="input7"
      @focus="handleFocus(7)"
      @keydown.delete="handleDelete(7, $event)"
      @input="handleInput(7)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 8"
    >
    <input
      class="cs-twofa__input"
      v-model="input8"
      ref="input8"
      @focus="handleFocus(8)"
      @keydown.delete="handleDelete(8, $event)"
      @input="handleInput(8)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 9"
    >
    <input
      class="cs-twofa__input"
      v-model="input9"
      ref="input9"
      @focus="handleFocus(9)"
      @keydown.delete="handleDelete(9, $event)"
      @input="handleInput(9)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 10"
    >
    <input
      class="cs-twofa__input"
      v-model="input10"
      ref="input10"
      @focus="handleFocus(10)"
      @keydown.delete="handleDelete(10, $event)"
      @input="handleInput(10)"
      v-on:keyup.enter="$emit('enter')"
      type="text"
      v-mask="'#'"
      autocomplete="off"
      v-if="count >= 11"
    >
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 7,
    },
  },
  data() {
    return {
      input0: '',
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: '',
      input6: '',
      input7: '',
      input8: '',
      input9: '',
      input10: '',
    };
  },
  computed: {
    code() {
      const inputs = [
        this.input0,
        this.input1,
        this.input2,
        this.input3,
        this.input4,
        this.input5,
        this.input6,
        this.input7,
        this.input8,
        this.input9,
        this.input10,
      ];
      this.$emit('input', inputs.join(''));
      return inputs.join('');
    },
  },
  methods: {
    focus() {
      this.$refs.input0.focus();
    },
    handleDelete(el, event) {
      event.preventDefault();
      if (!this.$refs[`input${el + 1}`]) {
        if (this[`input${el}`] === '') {
          this[`input${el - 1}`] = '';
          this.$refs[`input${el - 1}`].focus();
        } else {
          this[`input${el}`] = '';
        }
      } else if (this.$refs[`input${el - 1}`]) {
        this[`input${el - 1}`] = '';
        this.$refs[`input${el - 1}`].focus();
      }
    },
    handleFocus(el) {
      if (this.$refs[`input${el - 1}`] && !this[`input${el - 1}`]) this.$refs[`input${el - 1}`].focus();
      if (this.$refs[`input${el + 1}`] && this[`input${el}`]) this.$refs[`input${el + 1}`].focus();
    },
    handleInput(el) {
      // eslint-disable-next-line
      if (isNaN(this[`input${el}`])) this[`input${el}`] = '';
      if (this[`input${el}`] !== '') {
        if (this.$refs[`input${el + 1}`]) {
          this.$refs[`input${el + 1}`].focus();
        }
      }
    },
    clearCode() {
      this.input0 = '';
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      this.input5 = '';
      this.input6 = '';
      this.input7 = '';
      this.input8 = '';
      this.input9 = '';
      this.input10 = '';

      return 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-twofa {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  &__hide-result {
    display: none;
  }
  &__input {
    margin: 0 5px;
    height: 47px;
    border: 1px solid $border;
    border-radius: 1px;
    width: 100%;
    font-weight: 300;
    font-size: 20px;
    text-align: center;
    transition: .35s;
    max-width: 40px;
    &:focus {
      border-color: $black500;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
